import React from 'react';
import styles from './DeleteClinic.module.scss';

import {IoTrashOutline} from 'react-icons/io5';
import api from '../../../helpers/api';
import {$t} from '../../../helpers/translator';
import Modal from '../../miscellaneous/Modal/Modal';
import {setAlert} from "../../../store/alerts-slice";
import {connect} from "react-redux";


class DeleteClinic extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };
    }

    presentApprovalModal() {
        this.setState({showModal: true}, () => {
            // console.log(this.state)
        });
    }

    closeModals() {
        this.setState({showModal: false});
    }

    async deleteClinic() {
        try {
            let res = await api.delete(`clinic/${this.props.id}`);
            if (res && res.data && res.data.success) {
                this.props.onSuccess({success: true});
                this.props.dispatch(setAlert({type: 'success', body: $t('global.clinics.deleteSuccessMessage')}));
                this.setState({showModal: false});
            }
        } catch (e) {
            this.props.dispatch(setAlert({type: 'error'}));
            console.error('err deleting:', e);
        }
    }

    renderContent() {
        return (
            <div className={`${styles['delete-container']}`}>
                <div className={`${styles['first-row']}`}>
                    {$t('global.clinics.deleteClinic')}
                </div>
                <div className={`${styles['second-row']}`}>
                    {this.props.id ?
                        <div>
                            <span
                                style={{fontWeight: '300'}}>{$t('global.clinics.clinicId')}:</span> {this.props.id}
                        </div>
                        :
                        null
                    }
                    {this.props.clinicName ?
                        <div>
                            <span
                                style={{fontWeight: '300'}}>{$t('global.clinics.clinicName')}:</span> {this.props.clinicName}
                        </div>
                        :
                        null
                    }
                </div>

                <div className={`${styles['third-row']}`}>
                    {$t('global.clinics.deletionIsPermanent')}
                </div>
                <div className={`${styles['delete-approve']}`}>
                    <div className={`${styles['delete-button']}`}
                         onClick={() => this.deleteClinic()}>{$t('global.general.delete')}</div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className={`${styles['container']}`} style={this.props.style ? this.props.style : null}>
                <IoTrashOutline className={`${styles['icon']}`} onClick={() => this.presentApprovalModal()}/>

                <Modal content={this.renderContent()}
                       onClose={this.closeModals.bind(this)}
                       visible={this.state.showModal}/>
            </div>
        );
    }
}

// export default DeleteClinic;
const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(DeleteClinic);